<mapfre-card [singleCard]="false" [additionalClasses]="'policy-details'">
  <div class="single-card-column policy-card" [ngClass]="{'link-policy': !isAcmic}">
    <div class="row text-center">
      <div class="col">
        <h1 class="title-copy" [ngClass]="{ 'margin-bottom mb24': !isAcmic }">
          {{ "ADD_NEW_POLICY_TITLE" | translate }}
        </h1>
      </div>
    </div>
    <ng-container *ngIf="!isAcmic">
      <div class="row text-center mb-4">
        <div class="col">
          <mapfre-modal
            [modalOptions]="whereToFindModalOptions"
            [hideModal]="hideModal"
            (hideModalOutput)="resetHideModal()"
          >
            <div class="modal-body no-padding-top">
              <hr class="margin-bottom mb24" />
              <div class="margin-bottom mb8 fs-14">
                {{ "SEARCH_YOUR_POLICY_DOCUMENTS_INVOICES" | translate }}
              </div>
              <div class="margin-bottom mb24">
                <img src="./assets/img/images/Document_ref.png" alt="document ref" />
              </div>
              <mapfre-button
                additionalClasses="basic primary large-btn no-margin"
                (click)="hideModalAction()"
              >
                {{ "CLOSE" | translate }}
              </mapfre-button>
            </div>
          </mapfre-modal>
        </div>
      </div>
    </ng-container>
    <app-add-policy-form
      [inputs]="linkPolicy"
      [buttonLabel]="continueButton"
      [missingPolicyNumber]="missingPolicyNumber"
    ></app-add-policy-form>

    <ng-container *ngIf="isAcmic">
      <hr class="margin-vertical mv24" />
      <div class="row text-center margin-top mt16">
        <div class="col">
          <mapfre-modal
            [modalOptions]="whereToFindModalOptions"
            [hideModal]="hideModal"
            (hideModalOutput)="resetHideModal()"
          >
            <div class="modal-body no-padding-top">
              <hr class="margin-bottom mb24" />
              <div class="margin-bottom mb8 fs-14">
                {{ "SEARCH_IN_YOUR_POLICY_DOC_OR_INVOICES" | translate }}
              </div>
              <div class="margin-bottom mb24">
                <img src="./assets/img/images/Document_ref.svg" alt="document ref" />
              </div>
              <mapfre-button
                additionalClasses="basic primary large-btn no-margin"
                (click)="hideModalAction()"
              >
                {{ "CLOSE" | translate }}
              </mapfre-button>
            </div>
          </mapfre-modal>
        </div>
      </div>
    </ng-container>
  </div>
</mapfre-card>
